<template>
  <v-overlay
    :opacity="1"
    style="display: flex; justify-content: center; align-items: center"
  >
    <div>
      <v-progress-circular :width="8" :size="200" color="yellow" indeterminate>
        <template v-slot:default> loading </template>
      </v-progress-circular>
    </div>
  </v-overlay>
</template>
<script>
export default {};
</script>
